import { render, staticRenderFns } from "./EditOpenLog.vue?vue&type=template&id=31873deb&scoped=true&"
import script from "./EditOpenLog.vue?vue&type=script&lang=js&"
export * from "./EditOpenLog.vue?vue&type=script&lang=js&"
import style0 from "./EditOpenLog.vue?vue&type=style&index=0&id=31873deb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31873deb",
  null
  
)

export default component.exports